import PanelPage from "../../components/panel/panelPage";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import PanelSubHeading from "../../components/panel/subHeading";
import PanelHeading from "../../components/panel/heading";
import PanelSearch from "../../components/filters/panelSearch";
import { FilterIcon } from "../../icons/filter";
import UserListTable from "../../components/users/userListTable";
import TasksListTable from "../../components/activity/tasksListTable";
import EventsListTable from "../../components/activity/eventsListTable";
import { closeModal, openModal } from "../../state/modalSlice";
import CreateEventModal from "../../modals/event/createEvent";
import { eventBackend } from "../../services";
import EventFilterModal from "../../modals/filters/event";
import { EventListRequestParams } from "../../forms/filters/event";

const EventsListPage = () => {

  const [searchValue, setSearchValue] = useState("")
  const State = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const filters = State.eventListRequestParams

  const search = (value: string) => {
    setSearchValue(value);
    dispatch(actions.eventRequestParams({...filters, search_query: value}))
  }

  useEffect(() => {
    eventBackend.getAllEvents(filters).then((res) => {
      dispatch(actions.eventData(res.events));
      console.log(res.events)
    }).catch((e) => {
      console.log(e.error || e)
    })
  }, [filters])

  const handleOpenModal = () => {
    dispatch(openModal({ component: CreateEventModal, context: {
      onSave: (file: File) => {
        console.log('Сохранено фото:', file.name);
      },
      closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
    }, }));
  };

  const handleOpenFilters = () => {
    dispatch(openModal({ component: EventFilterModal, context: {
      onApplyFilters: (filters: EventListRequestParams) => {
        setSearchValue("");
        dispatch(actions.eventRequestParams(filters))
      },
      closeModal: () => dispatch(closeModal()), // Закрыть модальное окно через Redux
    }, }));
  }

  return (
    <PanelPage>
      <div className="panelColumnFull">
        <div className="profileWidget">
          <div className="flex between">
            <PanelSubHeading text="События" />
            <div className="panelBtnContainer">
              <div className="btn panelActionBtn" onClick={handleOpenModal}>+ Создать</div>
            </div>
          </div>
          <div className="flex between panelSearchContainer">
             <PanelSearch hint={"Поиск по названию"} onChange={search} />
             <div className="btn filterBtn" onClick={handleOpenFilters}>
                <FilterIcon width={20} height={20} />
             </div>
          </div>
          <EventsListTable search={searchValue} />
        </div>
      </div>
    </PanelPage>
  );
};

export default EventsListPage;
